import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Info, Input, Label, LabelWrapper, Wrapper } from './LabeledInput.style'

class LabeledInput extends Component {
    static propTypes = {
        danger: PropTypes.bool,
        id: PropTypes.string.isRequired,
        info: PropTypes.string,
        label: PropTypes.string.isRequired,
        onBlur: PropTypes.func,
        onChange: PropTypes.func.isRequired,
        onFocus: PropTypes.func,
        onPressEnter: PropTypes.func,
        type: PropTypes.string,
        value: PropTypes.string.isRequired,
    }

    static defaultProps = {
        danger: false,
        info: null,
        onBlur: () => {},
        onFocus: () => {},
        onPressEnter: () => {},
        type: 'text',
    }

    constructor(props) {
        super(props)

        this.state = {
            focused: false,
        }

        this.blurInput = this.blurInput.bind(this)
        this.focusInput = this.focusInput.bind(this)
        this.onKeyPress = this.onKeyPress.bind(this)
    }

    /**
     * on input key press
     * @param {object} event Input event
     */
    onKeyPress({ key }) {
        if (key === 'Enter') {
            const { onPressEnter } = this.props
            onPressEnter()
        }
    }

    focusInput() {
        const { onFocus } = this.props
        this.setState({ focused: true })
        onFocus()
    }

    blurInput() {
        const { onBlur } = this.props
        this.setState({ focused: false })
        onBlur()
    }

    render() {
        const { danger, id, info, label, onChange, type, value } = this.props
        const { focused } = this.state
        return (
            <Wrapper>
                <LabelWrapper htmlFor={id}>
                    <Label focused={focused || !!value}>{label}</Label>
                    <Input
                        type={type}
                        id={id}
                        name={id}
                        onBlur={this.blurInput}
                        onChange={onChange}
                        onFocus={this.focusInput}
                        onKeyPress={this.onKeyPress}
                        value={value}
                        danger={danger}
                    />
                    {info && <Info danger={danger}>{info}</Info>}
                </LabelWrapper>
            </Wrapper>
        )
    }
}

export default LabeledInput
